import React, { useEffect, useState } from "react";
import "./ActualitesPage.css";
import { fetchNews } from "../ServiceApi"; // Simule une API pour récupérer les actualités

const ActualitesPage = () => {
    const [news, setNews] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        const loadNews = async () => {
            setIsLoading(true);
            const newArticles = await fetchNews(currentPage);
            setNews((prevNews) => [...prevNews, ...newArticles]);
            setIsLoading(false);
        };

        loadNews();
    }, [currentPage]);

    const loadMore = () => {
        setCurrentPage((prevPage) => prevPage + 1);
    };

    return (
        <div className="actualites-page">
            <section className="intro">
                <h1>Actualités</h1>
                <p>Découvrez les dernières actualités et événements de notre club.</p>
            </section>

            <div className="news-container">
                {news.map((article) => (
                    <div key={article.id} className="news-card">
                        <img
                            src={article.image}
                            alt={article.title}
                            className="news-image"
                        />
                        <div className="news-content">
                            <h3 className="news-title">{article.title}</h3>
                            <p className="news-date">{article.date}</p>
                            <p className="news-summary">{article.summary}</p>
                            <button
                                className="read-more"
                                onClick={() => alert("Redirection vers l'article complet")}
                            >
                                Lire la suite
                            </button>
                        </div>
                    </div>
                ))}
            </div>

            {isLoading && <p className="loading-text">Chargement...</p>}

            <div className="load-more-container">
                <button className="load-more-btn" onClick={loadMore}>
                    Charger plus
                </button>
            </div>
        </div>
    );
};

export default ActualitesPage;
